module.exports = __webpack_public_path__ + "img/uncheckedBox.5b22ec32.svg";